<template>
    <!--固定广告轮播-->
    <swiper id="mySwiperFixed" class="mySwiperFixed" :options="swiperOption" ref="mySwiperFixed" v-if="adsList.length != 0">
      <swiper-slide class="swiperSlide" v-for="(item,index) in adsList" :key="index" >
        <img class="screenCon" :src="item.url" :alt="item.name" v-if="item.type == 'image'" />
        <video :class="'video'+(index+1)" class="screenCon video" :src="item.url" @ended="ended(index)" preload :muted="$store.state.fixedAdsPause" :loop="adsList.length === 1" v-else>您的浏览器不支持 video 标签。</video>
      </swiper-slide>
    </swiper>
    <img src="/static/Bookcase/images/ad.png" alt="" v-else>
</template>


<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { conLog, messageError } from '../../static/js/utils/utility'
import { commonApi } from '../../static/js/api'
import * as config from '../../static/js/config'

let vm, swiperTimer = ''

export default {
  name: 'ads',
  component: {
    swiper,
    swiperSlide
  },
  data(){
    return{
      adsList: [], // 广告列表

      swiperOption: {
        loop: true, // 循环播放
        effect : 'fade', // 切换效果
        observer: true, 
        observeParents: true,
        observeSlideChildren: true,
        on:{
          init: function(){
            let s_vm = this
            if (swiperTimer) { clearTimeout(swiperTimer) }
            // conLog('swiper初始化')
            //Swiper初始化了
            // conLog('当前的slide序号是'+s_vm.activeIndex);
            let activeIndex = s_vm.activeIndex  // 当前是第几屏
            let realIndex = s_vm.realIndex     // 当前索引
            if (vm.adsList[realIndex].type == 'video') {
              // conLog('开始加载视频')
              let slideList = document.getElementById('mySwiperFixed').getElementsByClassName('swiperSlide')
              let videoList = slideList[activeIndex].getElementsByClassName('video')
              // conLog('videoList::::', videoList)
              let mp4 = videoList[0]
              let promise = mp4.play()
              if (promise !== undefined) {
                promise.then(function(){
                  // Autoplay started!

                }).catch(function() {
                  // Autoplay was prevented.
                  // conLog('视频播放错误')
                  //--静音再播放--
                  // mp4.muted=true;
                  mp4.play()
                })
              }
              // conLog('init加载视频完成')
            } else {
              if (vm.adsList.length !== 1) {
                swiperTimer = setTimeout(() => {
                  let toIndex = realIndex+1
                  s_vm.slideToLoop(toIndex == vm.adsList.length ? 0 : toIndex)
                }, vm.adsList[realIndex].delay)
              }
            }
          },
          slideChange:function(){
            let s_vm = this
            if (swiperTimer) { clearTimeout(swiperTimer) }
            let activeIndex = s_vm.activeIndex  // 当前是第几屏
            let realIndex = s_vm.realIndex     // 当前索引
            if (vm.adsList[realIndex].type == 'video') {
              let slideList = document.getElementById('mySwiperFixed').getElementsByClassName('swiperSlide')
              let videoList = slideList[activeIndex].getElementsByClassName('video')
              // videoList[0].play()
              let mp4 = videoList[0]
              let promise = mp4.play()
              if (promise !== undefined) {
                promise.then(function(){
                  // Autoplay started!

                }).catch(function() {
                  // Autoplay was prevented.
                  // conLog('slideChange视频播放错误')
                  //--静音再播放--
                  // mp4.muted=true;
                  mp4.play()
                })
              }
            } else {
              swiperTimer = setTimeout(() => {
                // conLog('-----图片播放结束index', realIndex+1)
                  let toIndex = realIndex+1
                  s_vm.slideToLoop(toIndex == vm.adsList.length ? 0 : toIndex)
              }, vm.adsList[realIndex].delay)
            }
          },
        }
      },
    }
  },
  computed: {
  },
  async created(){
    vm = this
    vm.$nextTick(()=>{
      vm.getAdsList()
    })
    
  },
  mounted () {
  },
  methods:{
    ended (index) {
      // console.log('-----视频播放结束index', index+1)
      let toIndex = index + 1
      vm.$refs.mySwiperFixed.swiper.slideToLoop(toIndex == vm.adsList.length ? 0 : toIndex)
    },
    // 获取闲置广告列表(暂定12小时更新一次)
    async getAdsList () {
      let data = {
        cabinet_id: config.deviceId,
        type: 'fixed'
      } 

      let res = await commonApi.getAdsList(data)
      if (res.meta.code === 200) {
        let adsList = res.data.ads_list
        adsList.forEach(function (item, index) {
          if(item.type === 'image') {
            adsList[index].delay = res.data.config.rotation_second * 1000
          }
        })
        vm.adsList  = [...adsList]
      } else {
        messageError(res.meta.message)
      }
    },
  },
  watch: {
    // '$store.state.fixedAdsPause' (newVal) {
    //   console.log('$store.state.fixedAdsPause', vm.$store.state.fixedAdsPause)
    // }
  }
}
</script>

<style lang="less">
.mySwiperFixed {
  height: 100vh;
  width: 100vw;
  text-align: center;
  .swiper-slide {
    background-color: #cccccc;
  }
  .screenCon {
    display: block;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
    video {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/assets/ads.vue